// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { initializeAuth, browserLocalPersistence } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAt4fGfeYn6ONpuUPsXJAA3X11_nj4FjZU",
  authDomain: "rentable-inversor-web.firebaseapp.com",
  projectId: "rentable-inversor-web",
  storageBucket: "rentable-inversor-web.appspot.com",
  messagingSenderId: "993181302752",
  appId: "1:993181302752:web:e1abe650704912f3f67585",
  measurementId: "G-CJGM81HRDW",
};

const app = initializeApp(firebaseConfig);
const secondaryApp = initializeApp(firebaseConfig, "Secondary");

export const db = getFirestore(app);
export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
});
export const analytics = getAnalytics(app);

export const secondaryAuth = initializeAuth(secondaryApp, {
  persistence: browserLocalPersistence,
});
